/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * |Token | Name | Dimensions|
 *
 * @remarks
 * |:---|:---|:---|
 * | FedEx_Box_10kg | FedEx® 10kg Box | 15.81 x 12.94 x 10.19 in|
 * | FedEx_Box_25kg | FedEx® 25kg Box | 54.80 x 42.10 x 33.50 in|
 * | FedEx_Box_Extra_Large_1 | FedEx® Extra Large Box (X1) | 11.88 x 11.00 x 10.75 in|
 * | FedEx_Box_Extra_Large_2 | FedEx® Extra Large Box (X2) | 15.75 x 14.13 x 6.00 in|
 * | FedEx_Box_Large_1 | FedEx® Large Box (L1) | 17.50 x 12.38 x 3.00 in|
 * | FedEx_Box_Large_2 | FedEx® Large Box (L2) | 11.25 x 8.75 x 7.75 in|
 * | FedEx_Box_Medium_1 | FedEx® Medium Box (M1) | 13.25 x 11.50 x 2.38 in|
 * | FedEx_Box_Medium_2 | FedEx® Medium Box (M2) | 11.25 x 8.75 x 4.38 in|
 * | FedEx_Box_Small_1 | FedEx® Small Box (S1) | 12.38 x 10.88 x 1.50 in|
 * | FedEx_Box_Small_2 | FedEx® Small Box (S2) | 11.25 x 8.75 x 4.38 in|
 * | FedEx_Envelope | FedEx® Envelope | 12.50 x 9.50 x 0.80 in|
 * | FedEx_Padded_Pak | FedEx® Padded Pak | 11.75 x 14.75 x 2.00 in|
 * | FedEx_Pak_1 | FedEx® Large Pak | 15.50 x 12.00 x 0.80 in|
 * | FedEx_Pak_2 | FedEx® Small Pak | 12.75 x 10.25 x 0.80 in|
 * | FedEx_Tube | FedEx® Tube | 38.00 x 6.00 x 6.00 in|
 * | FedEx_XL_Pak | FedEx® Extra Large Pak | 17.50 x 20.75 x 2.00 in|
 */
export const ParcelTemplateFedExEnum = {
  FedExBox10kg: "FedEx_Box_10kg",
  FedExBox25kg: "FedEx_Box_25kg",
  FedExBoxExtraLarge1: "FedEx_Box_Extra_Large_1",
  FedExBoxExtraLarge2: "FedEx_Box_Extra_Large_2",
  FedExBoxLarge1: "FedEx_Box_Large_1",
  FedExBoxLarge2: "FedEx_Box_Large_2",
  FedExBoxMedium1: "FedEx_Box_Medium_1",
  FedExBoxMedium2: "FedEx_Box_Medium_2",
  FedExBoxSmall1: "FedEx_Box_Small_1",
  FedExBoxSmall2: "FedEx_Box_Small_2",
  FedExEnvelope: "FedEx_Envelope",
  FedExPaddedPak: "FedEx_Padded_Pak",
  FedExPak1: "FedEx_Pak_1",
  FedExPak2: "FedEx_Pak_2",
  FedExTube: "FedEx_Tube",
  FedExXLPak: "FedEx_XL_Pak",
} as const;
/**
 * |Token | Name | Dimensions|
 *
 * @remarks
 * |:---|:---|:---|
 * | FedEx_Box_10kg | FedEx® 10kg Box | 15.81 x 12.94 x 10.19 in|
 * | FedEx_Box_25kg | FedEx® 25kg Box | 54.80 x 42.10 x 33.50 in|
 * | FedEx_Box_Extra_Large_1 | FedEx® Extra Large Box (X1) | 11.88 x 11.00 x 10.75 in|
 * | FedEx_Box_Extra_Large_2 | FedEx® Extra Large Box (X2) | 15.75 x 14.13 x 6.00 in|
 * | FedEx_Box_Large_1 | FedEx® Large Box (L1) | 17.50 x 12.38 x 3.00 in|
 * | FedEx_Box_Large_2 | FedEx® Large Box (L2) | 11.25 x 8.75 x 7.75 in|
 * | FedEx_Box_Medium_1 | FedEx® Medium Box (M1) | 13.25 x 11.50 x 2.38 in|
 * | FedEx_Box_Medium_2 | FedEx® Medium Box (M2) | 11.25 x 8.75 x 4.38 in|
 * | FedEx_Box_Small_1 | FedEx® Small Box (S1) | 12.38 x 10.88 x 1.50 in|
 * | FedEx_Box_Small_2 | FedEx® Small Box (S2) | 11.25 x 8.75 x 4.38 in|
 * | FedEx_Envelope | FedEx® Envelope | 12.50 x 9.50 x 0.80 in|
 * | FedEx_Padded_Pak | FedEx® Padded Pak | 11.75 x 14.75 x 2.00 in|
 * | FedEx_Pak_1 | FedEx® Large Pak | 15.50 x 12.00 x 0.80 in|
 * | FedEx_Pak_2 | FedEx® Small Pak | 12.75 x 10.25 x 0.80 in|
 * | FedEx_Tube | FedEx® Tube | 38.00 x 6.00 x 6.00 in|
 * | FedEx_XL_Pak | FedEx® Extra Large Pak | 17.50 x 20.75 x 2.00 in|
 */
export type ParcelTemplateFedExEnum = ClosedEnum<
  typeof ParcelTemplateFedExEnum
>;

/** @internal */
export const ParcelTemplateFedExEnum$inboundSchema: z.ZodNativeEnum<
  typeof ParcelTemplateFedExEnum
> = z.nativeEnum(ParcelTemplateFedExEnum);

/** @internal */
export const ParcelTemplateFedExEnum$outboundSchema: z.ZodNativeEnum<
  typeof ParcelTemplateFedExEnum
> = ParcelTemplateFedExEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ParcelTemplateFedExEnum$ {
  /** @deprecated use `ParcelTemplateFedExEnum$inboundSchema` instead. */
  export const inboundSchema = ParcelTemplateFedExEnum$inboundSchema;
  /** @deprecated use `ParcelTemplateFedExEnum$outboundSchema` instead. */
  export const outboundSchema = ParcelTemplateFedExEnum$outboundSchema;
}
